<div class="modal-header" *ngIf="isModal">
  <h5 class="modal-title">{{'listino.editTitle' | translate}}</h5>
  <button type="button" class="close" (click)="close()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div [ngClass]="{'modal-body': isModal, 'card': !isModal}">
  <div [ngClass]="{'card-body': !isModal}">
    <div class="row" >
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label for="fornitore" class="control-label col-form-label">{{'listino.import.fornitore' | translate}}</label>
          <ng-multiselect-dropdown [settings]="clientiDropdownSettings" [placeholder]="'listino.import.fornitore' | translate" id="fornitore"
                                   [data]="Fornitori" [(ngModel)]="FornitoriSelezionati"  >
          </ng-multiselect-dropdown>
        </div>
      </div>
      <div class="col-sm-12 col-md-12">
        <div class="form-group">
          <label for="data" class="control-label col-form-label">{{'listino.import.data' | translate}}:</label>
          <input type="date" [(ngModel)]="listino.data"  class="form-control" id="data">
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="save()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> {{'listino.salva' | translate}} </span>
  </button>
</div>
<div class="card" *ngIf="listino.id">
  <div class="card-body">
    <app-lista-prodotti
      #prodotti
      [ListType]="'listino'"
      (AddClicked)="AddProdotto()"
      (UpdateClicked)="UpdateProdotto($event)"
      (DeleteClicked)="DeleteProdotto($event)"
      (RestoreClicked)="RestoreProdotto($event)"
      [idListino]="listino.id"
      [HasFilter]="false"
      [externalAddFunction]="true"
      [externalEditFunction]="true"
      [externalDeleteFunction]="true"
      [externalRestoreFunction]="true"
      [HasOpenButton]="false"
      [HasRestoreButton]="false"
      [HasDeleteButton]="false"
      [HasEliminatiButton]="false"
    ></app-lista-prodotti>
  </div>
</div>

